var map = {
	"./10_nuts.png": 2540,
	"./1drink_12beer.png": 2541,
	"./1serving_8ounces.png": 2542,
	"./1serving_8ounces2.png": 2543,
	"./1serving_8ounces3.png": 2544,
	"./1serving_8ounces4.png": 2545,
	"./1serving_8ounces5.png": 2546,
	"./8ounces_1glass.png": 2547,
	"./can_1.png": 2548,
	"./can_2.png": 2549,
	"./can_3.png": 2550,
	"./cup.png": 2551,
	"./dried_serving_1/4cup.png": 2552,
	"./dried_serving_1:4cup.png": 2553,
	"./fresh_serving_1cup.png": 2554,
	"./glass_1.png": 2555,
	"./glass_2.png": 2556,
	"./golfball.png": 2557,
	"./halfthumb.png": 2558,
	"./hand_1.png": 2559,
	"./hand_2.png": 2560,
	"./hand_3.png": 2561,
	"./hand_4.png": 2562,
	"./hand_5.png": 2563,
	"./how.png": 873,
	"./serving_1/2cup.png": 2564,
	"./serving_1:2cup.png": 2565,
	"./serving_1tbsp.png": 2566,
	"./serving_3/4ounces.png": 2567,
	"./serving_3:4ounces.png": 2568,
	"./thumbx2.png": 2569,
	"./usda.png": 2570,
	"./vegetables_1cup.png": 2571,
	"./what.png": 871,
	"./wholethumb.png": 2572,
	"./why.png": 872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2539;